import { ready } from '@titanio/utils'
import textfield from '@magnetita/textfield'
import tracker from '@titanio/tracker'

import user from '@presignin/src/user'
import a11y from '@presignin/src/a11y'
import Presignin from '@presignin/presignin'
import buttonLoading from '@modules/buttonLoading'
import tracking from '@modules/tracking'
import leadTracking from '@modules/lead-tracking'

ready(() => {
  setTimeout(() => textfield.mount(), 0)
  setTimeout(() => buttonLoading.mount(), 0)
  setTimeout(() => {
    const presignin = new Presignin()
    presignin.mount()
  }, 0)

  setTimeout(() => user.mount(), 0)
  setTimeout(() => a11y.mount(), 0)
  setTimeout(() => tracker.mount(), 0)
  setTimeout(() => tracking.loader(), 0)
  setTimeout(() => leadTracking.mount(), 0)
  setTimeout(() => {
    if (!document.body.classList.contains('has-otl')) return

    import(
      /* webpackChunkName: "one-tap-login" */
      '@titanio/one-tap-login'
    ).then((module) => {
      const otsignin = module.default
      otsignin.mount()
    })
  }, 0)
})
